import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Client } from 'src/app/clients-module/models/clientLocation';
import { ClientService } from 'src/app/clients-module/services/client.service';
import { AuthService } from 'src/app/services/auth.service';
import { ProcessorReportsService, ProcessorReport } from 'src/app/services/processor-reports.service';

@Component({
  selector: 'app-div-invite-report-dialog',
  templateUrl: './div-invite-report-dialog.component.html',
  styleUrls: ['./div-invite-report-dialog.component.less']
})
export class DivInviteReportDialogComponent implements OnInit, OnDestroy {
  report!: ProcessorReport;
  public startDate: any;
  public endDate: any;
  availableClients!: Client[];
  clientSub$!: Subscription;
  selectedClient!: Client;
  loading!: boolean;
  partyOn: Subject<any> = new Subject<any>();

  constructor(
    public modalRef: NgbModal,
    public procRpts: ProcessorReportsService,
    public auth: AuthService,
    public client: ClientService,
    public toast: ToastrService
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.clientSub$ = this.client.FetchLightClientList().pipe(
      tap(_ => {
        this.availableClients = _;
        this.loading = false;
      })
    ).subscribe();
  }

  ngOnDestroy(): void {
    this.modalRef.dismissAll();
    if (this.clientSub$) {
      this.clientSub$.unsubscribe();
    }
  }

  cancel(): void {
    this.modalRef.dismissAll();
  }

  download(): void {
    if (!this.selectedClient || !this.selectedClient.id) {
      this.toast.error('Please select a client.');
      return;
    }

    if (!this.startDate) {
      this.toast.error('Please select a start date.');
      return;
    }

    var vals: any = {};
    vals['clientId'] = this.selectedClient.id;
    vals['startDate'] = this.startDate;
    vals['endDate'] = this.endDate ? this.endDate : new Date().toISOString().split('T')[0];
    this.partyOn.next(vals);
  }
}
